import Trip from '../types/Trip';

/** Get key details from the Trip, like hiredBid and hiredBidConversation without copy/pasting the code everywhere */
function getTripKeyDetails(trip: Trip) {
  const hiredBid =
    trip.conversations.map((c) => c.bid).find((b) => b?.id === trip.hiredBid) ||
    null;

  const hiredBidConversation =
    trip.conversations.find((c) => c.bid?.id === trip.hiredBid) || null;

  return { hiredBid, hiredBidConversation };
}

export default getTripKeyDetails;
